import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React, {useContext} from 'react';

import {NewStorageCheckoutModal} from '../../../pages/Billing/Checkout/NewStorageCheckoutModal';
import {TRIAL_END_PATH} from '../../../routes/onboarding/onboardingPaths';
import {
  StripeElementsComp,
  useAccountPrivileges,
} from '../../../util/accounts/pricing';
import * as urls from '../../../util/urls';
import {AccountSelectorContext} from '../../Search/SearchNav/AccountSelectorContextProvider';

export function ContactSalesCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="my-0 border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={urls.contactSalesPricing()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Talk to sales
        </TargetBlank>
      </Button>
    </div>
  );
}

export function ContactSupportCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex  items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={urls.contactSupportOther()}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Talk to support
        </TargetBlank>
      </Button>
    </div>
  );
}

export function UpgradePlanCTA({shouldUnderline = false}) {
  return (
    <div className="my-[-16px] ml-auto flex items-center gap-8">
      <Button
        variant="outline"
        size="large"
        className="border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
        <TargetBlank
          href={TRIAL_END_PATH}
          className={`font-semibold ${shouldUnderline ? 'underline' : ''}`}>
          Upgrade plan
        </TargetBlank>
      </Button>
    </div>
  );
}

export function ActivateCTA({shouldUnderline = false}) {
  const [showUpgradeModel, setShowUpgradeModel] = React.useState(false);
  const {selectedAccount} = useContext(AccountSelectorContext);
  // we could pass this in from parent scope to avoid re-query but parent scope doesn't use privileges atm lol
  const {privileges} = useAccountPrivileges(selectedAccount);
  return (
    <>
      <div className="my-[-16px] ml-auto flex items-center gap-8">
        <Button
          variant="outline"
          size="large"
          onClick={() => setShowUpgradeModel(true)}
          className="border-moon-750 bg-transparent text-moon-800 hover:border-moon-750 hover:bg-white/[.20] [&>a]:text-moon-800">
          Activate pay-as-you-go
        </Button>
      </div>
      {showUpgradeModel && privileges && (
        <StripeElementsComp>
          <NewStorageCheckoutModal
            onTransactionCompleted={() => setShowUpgradeModel(false)}
            onClose={() => setShowUpgradeModel(false)}
            orgID={selectedAccount?.id ?? ''}
            freeStorageInGB={1 /*?*/}
            primarySub={null /*pls work lol*/}
            privileges={privileges!}
            isBuyingInference={true}
          />
        </StripeElementsComp>
      )}
    </>
  );
}
